// extracted by mini-css-extract-plugin
export var checkmark = "features-list-module--checkmark--92521";
export var featuresList = "features-list-module--featuresList--c8a52";
export var listText = "features-list-module--listText--6a27b";
export var xmark = "features-list-module--xmark--d08c2";